export default __webpack_public_path__ + "static/media/劉邦鋒.79f8cb8b.jpg";